import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

export class GoBiz extends Component {
  static propTypes = {
    close: PropTypes.func.isRequired,
  };
  constructor(props) {
    super(props);
    this.submitBusinessForm = this.submitBusinessForm.bind(this);
    this.state = {email: '', companyname: '', gst: ''};
  }

  submitBusinessForm() {
    const url = '/profiles/business/v1.0/add_business_email/';
    if (!this.state.email) {
      document.querySelector('#errorEmailMessage').innerText =
        'Corporate Email is mandatory to create business profile.';
      return;
    }
    const data =
      'gstin=' +
      this.state.gst +
      '&company=' +
      this.state.companyname +
      '&email=' +
      this.state.email;
    const config = {
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      withCredentials: true,
    };
    axios
      .post(url, data, config)
      .then(response => {
        const responseData = response.data;
        if (responseData.success) {
          document.querySelector('#verificationMsg').innerText = responseData.message;
          document.querySelector('#gstFormSubmission').classList.add('dn');
        } else {
          document.querySelector('#verificationMsg').innerText =
            'Something went wrong, please try later.';
        }
      })
      .catch(err => {
        document.querySelector('#errorEmailMessage').innerText = err.data.message;
      });
  }

  render() {
    const {close} = this.props;
    return (
      <div>
        <div className="popOverlay popShow" onClick={close}></div>
        <div className="popModal zoom small popShow db" id="signUpBusiness">
          <div className="popContent">
            <a
              href="javascript:void(0)"
              onClick={close}
              className="fr icon-close font12Lt popClose closeWhite"
            ></a>
            <div className="popBody">
              <div className="topOuterBlk posRel">
                <div className="carousel-container">
                  <div className="carousel carousel--translate">
                    <input
                      className="carousel__activator"
                      type="radio"
                      name="carousel"
                      id="F"
                      defaultChecked="checked"
                    />
                    <input className="carousel__activator" type="radio" name="carousel" id="G" />
                    <input className="carousel__activator" type="radio" name="carousel" id="H" />
                    <div className="carousel__track">
                      <div className="carousel__slide">
                        <div
                          className="width100 fl padLR10 padT10 posRel"
                          style={{height: '100%', background: '#2d67b2'}}
                        >
                          <span className="fileImg backSprite"></span>
                          <div className="width100 fl txtLeft">
                            <span className="width100 fl ico18 fmed white"></span>
                            <span className="width100 fl ico16 lh1-5 white padT20">
                              Easy reimburshments with <br />
                              GST Compliance invoices
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="carousel__slide posRel">
                        <div
                          className="width100 fl padLR10 padT10 posRel"
                          style={{height: '100%', background: '#2d67b2'}}
                        >
                          <span className="moneyImg backSprite"></span>
                          <div className="width100 fl txtLeft">
                            <span className="width100 fl ico18 fmed white"></span>
                            <span className="width100 fl ico16 lh1-5 white padT20">
                              Earn goCash and save big <br /> on your personal travel <br />
                              bookings
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="carousel__slide">
                        <div
                          className="width100 fl padLR10 padT10 posRel"
                          style={{height: '100%', background: '#2d67b2'}}
                        >
                          <span className="giftImg backSprite"></span>
                          <div className="width100 fl txtLeft">
                            <span className="width100 fl ico18 fmed white"></span>
                            <span className="width100 fl ico16 lh1-5 white padT20">
                              Avail deals exclusive to <br /> corporate users
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="carousel__indicators">
                      <label className="carousel__indicator" htmlFor="F"></label>
                      <label className="carousel__indicator" htmlFor="G"></label>
                      <label className="carousel__indicator" htmlFor="H"></label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="gstInfoBlk">
                <div className="width100 fl" id="gstFormSubmission">
                  <span className="width100 fl ico20 fmed greyDr">Create Business Profile</span>
                  <span className="width100 fl padT10">
                    <input
                      type="text"
                      name=""
                      className="form-control customInput"
                      placeholder="Business Email"
                      id="gstBusinessEmail"
                      required
                      value={this.state.email}
                      onChange={event => this.setState({email: event.target.value})}
                    />
                    <span id="errorEmail"></span>
                  </span>
                  <span className="width100 fl padT10">
                    <input
                      type="text"
                      name=""
                      className="form-control customInput"
                      placeholder="Company Name"
                      id="gstBusinessCompanyName"
                      value={this.state.companyname}
                      onChange={event => this.setState({companyname: event.target.value})}
                    />
                    <span id="errorCompanyName"></span>
                  </span>
                  <span className="width100 fl padT10">
                    <input
                      type="text"
                      name=""
                      className="form-control customInput"
                      placeholder="Business GST Number (Optional)"
                      id="gstBusinessGSTNumber"
                      value={this.state.gst}
                      onChange={event => this.setState({gst: event.target.value})}
                    />
                  </span>
                  <span className="width100 fl padT10">
                    <button
                      className="button orange large width100"
                      onClick={this.submitBusinessForm}
                    >
                      Continue
                    </button>
                  </span>
                  <span className="fl ico16 redDr padT10" id="errorEmailMessage"></span>
                </div>
                <div className="width100 fl">
                  <span className="fl ico16 greyDr padT10" id="verificationMsg"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
// export default (GoBiz);
